import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type RequestNewSupplierPayload,
  type RequestNewSupplierResponse,
} from './types';
import {
  zodRequestNewSupplierPayloadSchema,
  zodRequestNewSupplierResponseSchema,
} from './validations';

/**
 * Creates a supplier request for a supplier not on the VESTIGAS network.
 *
 * Responds with 409 if a submitted identifier matches an existing supplier.
 *
 * @param payload - The supplier name, recipient company ID, and optional identifiers (VAT ID, HRA, HRB, GLN) and contact email.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The created supplier request.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/post_unlisted_supplier_suppliers_requests_post
 */
export const requestNewSupplier = async (
  payload: RequestNewSupplierPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.SUPPLIER.REQUEST_NEW(), {
      ...options,
      json: payload,
      validate: {
        ...options?.validate,
        body: zodRequestNewSupplierPayloadSchema,
        response: zodRequestNewSupplierResponseSchema,
      },
    })
    .json<RequestNewSupplierResponse>();
